<template>
  <div class="base_main bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('PersonnelManagement') }} > {{ $t('activityStatistics') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <el-form :inline="true" :model="formStatic" class="demo-form-inline">
          <!-- 统计时段 -->
          <el-form-item :label="$t('statisticalPeriod')" class="datetime">
            <el-date-picker
              v-model="formStatic.startStatisticsTime"
              :placeholder="$t('startDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="totime">
            <el-date-picker
              v-model="formStatic.endStatisticsTime"
              :placeholder="$t('endDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('lastActiveTime')" class="datetime">
            <el-date-picker
              v-model="formStatic.lastActiveStartTime"
              :placeholder="$t('startDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="totime">
            <el-date-picker
              v-model="formStatic.lastActiveEndTime"
              :placeholder="$t('endDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <!-- 在岗时长 -->
          <el-form-item :label="$t('activeDuration')" class="datetime">
            <el-input
              clearable
              :placeholder="$t('minimumHour')"
              type="number"
              v-model="formStatic.minActive"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="totime">
            <el-input
              clearable
              :placeholder="$t('maximumHour')"
              type="number"
              v-model="formStatic.maxActive"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('activeDistance')" class="datetime">
            <el-input
              clearable
              :placeholder="$t('minimumDistance')"
              type="number"
              v-model="formStatic.minDistance"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="totime">
            <el-input
              clearable
              :placeholder="$t('maximumDistance')"
              type="number"
              v-model="formStatic.maxDistance"
            ></el-input>
          </el-form-item>
          <!-- 机构列表 -->
          <el-form-item :label="$t('mechanism')">
            <el-select
              ref="paramOuSelect"
              v-model="formStatic.ouName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              :popper-append-to-body="false"
              @change="changeOu"
              clearable
              @visible-change="visibleChange"
            >
              <el-option :value="formStatic.ouName" style="height:auto;padding:0px">
                <el-tree
                  ref="paramOuTree"
                  node-key="id"
                  default-expand-all
                  highlight-current
                  :expand-on-click-node="false"
                  :data="ouList"
                  :props="defaultProps"
                  @node-click="selectParamOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 用户名 -->
          <el-form-item :label="$t('userNameH')">
            <el-input v-model="formStatic.userName" clearable :placeholder="$t('userNameH')"></el-input>
          </el-form-item>
          <!-- 按钮 -->
          <el-form-item>
            <el-button type="primary" @click="getList" class="serachBtn">{{ $t('query') }}</el-button>
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- table开始 -->
      <div class="table-box">
        <Table
          :tableHeight="600"
          :data="tableData"
          :columns="columns"
          :operation="dateOperation"
          :showSelcet="false"
          @getList="getList"
          :currentPage="currentPage"
          :pageSize="pageSize"
          ref="tanleAssembly"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { statisticsPage } from '@/api/new-person/newPerson'
import { getOus } from '@/api/UserList'
import { nowDate, beforeMonthDate } from '@/util/date'
import { getExportStatistics } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
// 引入table组件
import Table from '@/components/NewTable'
export default {
  data() {
    return {
      // 查询表单
      formStatic: {
        userName: '',
        ouId: null,
        ouName: '',
        startStatisticsTime: beforeMonthDate(),
        endStatisticsTime: nowDate(),
      },
      columns: [],
      dateOperation: [],
      // table 数据
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      // 机构列表
      ouList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if(this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        userName: this.formStatic.userName,
        ouId: this.formStatic.ouId,
        startStatisticsTime: this.formStatic.startStatisticsTime,
        endStatisticsTime: this.formStatic.endStatisticsTime,
        lastActiveStartTime: this.formStatic.lastActiveStartTime,
        lastActiveEndTime: this.formStatic.lastActiveEndTime,
        minActive: this.formStatic.minActive ? this.formStatic.minActive * 60 : null,
        maxActive: this.formStatic.maxActive ? this.formStatic.maxActive * 60 : null,
        minDistance: this.formStatic.minDistance,
        maxDistance: this.formStatic.maxDistance,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type: 0,
        sortColName: this.formStatic.sortColName,
        useAsc: this.formStatic.useAsc
      }
      getExportStatistics(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('activityStatistics') + '.xls')
      })
    },
    // 排序
    handleSort(data) {
      console.log(data)
      this.formStatic.sortColName = !data.order ? null : data.column.sortable
      this.formStatic.useAsc = data.order=== "descending" ? 0 : 1
      this.getList()
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formStatic.ouName = data.name
      this.formStatic.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 清空过滤条件机构，过滤用户
    changeOu(data) {
      if (!data) {
        this.formStatic.ouId = null
        this.formStatic.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 查询列表
    getList() {
      this.currentPage = 1
      this.search()
    },
    // 获取table数据
    search() {
      let params = {
        userName: this.formStatic.userName,
        ouId: this.formStatic.ouId,
        startStatisticsTime: this.formStatic.startStatisticsTime,
        endStatisticsTime: this.formStatic.endStatisticsTime,
        lastActiveStartTime: this.formStatic.lastActiveStartTime,
        lastActiveEndTime: this.formStatic.lastActiveEndTime,
        minActive: this.formStatic.minActive ? this.formStatic.minActive * 60 : null,
        maxActive: this.formStatic.maxActive ? this.formStatic.maxActive * 60 : null,
        minDistance: this.formStatic.minDistance,
        maxDistance: this.formStatic.maxDistance,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type: 0,
        sortColName: this.formStatic.sortColName,
        useAsc: this.formStatic.useAsc
      }
      statisticsPage(params).then(res => {
        if (res.state === 0) {
          if (res.value.list) {
            this.tableData = res.value.list.map(item => {
              item.allactive = item.active ? (item.active / 60).toFixed(2) : 0 //总、分钟化小时
              item.dayAvgActive = item.avgActive ? (item.avgActive / 60).toFixed(2) : 0 //日、分钟化小时
              item.staticTime =
                item.startStatisticsTime && item.endStatisticsTime
                  ? item.startStatisticsTime.split(' ')[0] + this.$t('TO') + item.endStatisticsTime.split(' ')[0]
                  : '' //统计时间
              let data = ''
              if (item.activePeriodList && item.activePeriodList.length > 0) {
                item.activePeriodList = item.activePeriodList.map(val => {
                  val = Number(val) + this.$t('days')
                  data += val
                  return val
                })
              }
              item.activeList = data
              return item
            })
          } else {
            this.tableData = []
          }
          this.totalData = res.value.total
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    baseConfig() {
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
          allowHande: 'dataCenter',
          sort: 'userName',
        },
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'staticTime',
          label: this.$t('statisticalPeriod'),
          align: 'center',
          width: '200',
          sort: 'startStatisticsTime',
        },
        {
          attrName: 'allactive',
          label: this.$t('totalActiveHours'),
          width: '100',
          align: 'right',
          sort: 'active',
        },
        {
          attrName: 'dayAvgActive',
          label: this.$t('dailyActiveHours'),
          width: '100',
          align: 'right',
          sort: 'active',
        },
        {
          attrName: 'avgDistance',
          label: this.$t('dailyAverageDistance'),
          width: '160',
          align: 'right',
          sort: 'distance',
        },
        {
          attrName: 'activeList',
          label: this.$t('mainActivePeriods'),
          align: 'left',
          sort: 'activePeriod',
        },
        {
          attrName: 'lastActiveTime',
          label: this.$t('lastActiveTime'),
          width: '180',
          align: 'center',
          sort: 'lastActiveTime',
        },
        {
          attrName: 'lastActivePosition',
          label: this.$t('lastActivePosition'),
          sort: 'lastActivePosition',
        },
      ]
    },
  },

  mounted() {
    this.baseConfig()
    this.getOusTree()
    this.search()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl';
@import '~@/style/new-set-common.styl'
.base_main
  .common-table-cnt
    >>>.el-table
      height 600px!important;/*no*/
      min-height 500px!important;/*no*/
      overflow auto;
    .datetime,.totime
      >>>.el-input
        width 140px!important;/*no*/
    .el-button
      margin-left 10px
    .timeInterval
      display flex
      justify-content space-between
      flex-wrap wrap
    .pagination
      float right
      margin-top 10px
>>>.el-popper
  min-width 200px!important;/*no*/
>>>.el-form-item__label
  min-width 60px;/* no */
.totime
  >>>.el-form-item__label
    min-width 20px;/* no */
>>>.el-tree-node__content
  color: var(--new-el-select-dropdown-item);
</style>
